import type { SwadeItemInterface } from "@/types/items";

export type Priced = Pick<SwadeItemInterface, 'cost'> | null | undefined;

/**
 * What one unit of an item costs. A blank, missing or non-numeric cost is 0 — the parse the
 * CurrencyAdjuster has always used for its amount, shared so its hosts can ask the same question
 * before opening it.
 */
export const itemUnitCost = (item: Priced): number => parseFloat(String(item?.cost ?? 0)) || 0;

/**
 * Whether adding or removing the item has anything to charge or refund (owner's ruling
 * 2026-09-28). `!== 0` rather than `> 0`: a negative cost, not expected in the data, keeps opening
 * the adjuster as it always has.
 */
export const hasCost = (item: Priced): boolean => itemUnitCost(item) !== 0;
